import React from 'react';
import classnames from 'classnames';
import Slider, { DefaultPreviousButton, DefaultNextButton } from '@wix/da-ds/pkg/Slider';

import s from './AttachmentThumbSlider.scss';

export interface Props {
  className?: string;
  disableArrows?: boolean;
  scrollToIndex?: number;
  isSortable?: boolean;
}

export const AttachmentThumbSlider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  isSortable,
  ...sliderProps
}) => {
  return (
    <div className={classnames(s['slider-wrapper'], isSortable && s['is-sortable'], className)}>
      <Slider
        className={s['slider']}
        {...sliderProps}
        renderPrevButton={({ onClick, className: prevButtonClassName }) => (
          <DefaultPreviousButton
            onClick={onClick}
            className={classnames(prevButtonClassName, s['prev-button'])}
          />
        )}
        renderNextButton={({ onClick, className: nextButtonClassName }) => (
          <DefaultNextButton
            onClick={onClick}
            className={classnames(nextButtonClassName, s['next-button'])}
          />
        )}
      >
        {children}
      </Slider>
    </div>
  );
};
AttachmentThumbSlider.displayName = 'AttachmentThumbSlider';

export default AttachmentThumbSlider;
